
(function(){
  "use strict";
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Immersif complet aussi sur mobile (transformation sticky + usages horizontal) — voulu par Ben
  var isMobile = false;

  // Si reduced-motion : on n'anime rien, tout le contenu est déjà affiché par le CSS.
  if(reduce || !window.gsap){
    document.querySelectorAll('.reveal-line > span').forEach(function(s){s.style.transform='none';});
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  /* ── Lenis smooth scroll, synchronisé avec ScrollTrigger ── */
  var lenis;
  if(window.Lenis){
    lenis = new Lenis({ duration:1.1, easing:function(t){return Math.min(1,1.001-Math.pow(2,-10*t));}, smoothWheel:true });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function(time){ lenis.raf(time*1000); });
    gsap.ticker.lagSmoothing(0);
    // Resynchronise la limite de scroll de Lenis quand GSAP recalcule la hauteur
    // (les pins ajoutent de la hauteur -> sinon le bas de page/footer devient inatteignable)
    ScrollTrigger.addEventListener('refresh', function(){ lenis.resize(); });
  }

  var EASE = "power3.out"; // ~ cubic-bezier(0.16,1,0.3,1)

  /* ── 1 · HERO — révélation des titres ligne par ligne ── */
  gsap.from('.hero__titre .reveal-line > span', {
    yPercent:110, duration:1.1, ease:EASE, stagger:0.12, delay:0.15
  });
  gsap.from('.hero__cotes .mono', { y:16, opacity:0, duration:0.9, ease:EASE, stagger:0.08, delay:0.7 });
  // Parallaxe légère sur le hero
  gsap.to('.hero__media img', {
    yPercent:12, ease:'none',
    scrollTrigger:{ trigger:'.hero', start:'top top', end:'bottom top', scrub:true }
  });

  /* ── 2 · TRANSFORMATION — sticky, scroll pilote la séquence + fond noir→sable ── */
  var frames = gsap.utils.toArray('.transfo__frame');
  var steps  = gsap.utils.toArray('.transfo__step');
  var pin    = document.querySelector('.transfo__pin');

  var tfTl = gsap.timeline({
    scrollTrigger:{
      trigger:'.transfo', start:'top top', end:'+=250%',
      scrub:true, pin: isMobile ? false : '.transfo__pin'
    }
  });
  // Fond : noir → sable
  tfTl.to(pin, { backgroundColor:'#F2EFE9', ease:'none', duration:3 }, 0);
  // Crossfade + scale entre les 3 images clés
  tfTl.to(frames[0], { opacity:0, scale:1.04, duration:1, ease:'none' }, 0.6)
      .fromTo(frames[1], { opacity:0, scale:0.98 }, { opacity:1, scale:1, duration:1, ease:'none' }, 0.6)
      .to(frames[1], { opacity:0, scale:1.04, duration:1, ease:'none' }, 1.8)
      .fromTo(frames[2], { opacity:0, scale:0.98 }, { opacity:1, scale:1, duration:1, ease:'none' }, 1.8);

  // Synchronise les 3 blocs de texte
  function setStep(i){ steps.forEach(function(s,n){ s.classList.toggle('is-active', n===i); }); }
  ScrollTrigger.create({ trigger:'.transfo', start:'top top',   end:'+=250%',
    onUpdate:function(self){
      var p=self.progress; setStep(p<0.4?0:(p<0.72?1:2));
    }
  });

  /* ── 3 · USAGES — défilé auto (crossfade + Ken Burns), synchronisé avec la nav ── */
  (function(){
    var slides = gsap.utils.toArray('.usecase__slide');
    var navs   = gsap.utils.toArray('.usecase__nav li');
    if(slides.length < 2) return;
    var i = 0, timer = null;
    function go(n){
      i = (n + slides.length) % slides.length;
      slides.forEach(function(s,k){ s.classList.toggle('is-on', k===i); });
      navs.forEach(function(s,k){ s.classList.toggle('is-on', k===i); });
    }
    function next(){ go(i+1); }
    function start(){ stop(); timer = setInterval(next, 3200); }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    navs.forEach(function(n){ n.addEventListener('click', function(){ go(+n.dataset.i); start(); }); });
    ScrollTrigger.create({ trigger:'.usecase', start:'top 70%', end:'bottom 30%',
      onToggle:function(self){ self.isActive ? start() : stop(); } });
  })();
  gsap.from('.usecase__text > *', { y:24, opacity:0, duration:0.8, ease:EASE, stagger:0.08,
    scrollTrigger:{ trigger:'.usecase', start:'top 62%' } });
  gsap.from('.usecase__media', { opacity:0, x:30, duration:0.9, ease:EASE,
    scrollTrigger:{ trigger:'.usecase', start:'top 62%' } });

  /* ── 4 · RANGEMENT — hotspots qui apparaissent un à un ── */
  gsap.utils.toArray('.hotspot').forEach(function(h,i){
    if(h.hasAttribute('hidden')) return;
    ScrollTrigger.create({
      trigger:'.rangement__plan', start:'top 65%',
      onEnter:function(){ gsap.delayedCall(i*0.16, function(){ h.classList.add('is-in'); }); }
    });
  });
  gsap.utils.toArray('.rangement__list li').forEach(function(li,i){
    gsap.from(li, { x:20, opacity:0, duration:0.6, ease:EASE,
      scrollTrigger:{ trigger:li, start:'top 88%' } });
  });
  // Titre section révélé
  gsap.from('.rangement__head .titre', { y:30, opacity:0, duration:0.9, ease:EASE,
    scrollTrigger:{ trigger:'.rangement__head', start:'top 80%' } });

  /* ── 5 · MATIÈRE — révélation par masque vertical + parallaxe ── */
  gsap.to('.matiere__mask', { scaleY:0, ease:'none',
    scrollTrigger:{ trigger:'.matiere', start:'top 70%', end:'top 10%', scrub:true } });
  gsap.from('.matiere__lignes li', { y:24, opacity:0, duration:0.7, ease:EASE, stagger:0.12,
    scrollTrigger:{ trigger:'.matiere__lignes', start:'top 78%' } });
  gsap.to('.matiere__media img', { yPercent:10, ease:'none',
    scrollTrigger:{ trigger:'.matiere', start:'top bottom', end:'bottom top', scrub:true } });

  /* ── 6 · USAGES — bande horizontale pilotée par le scroll vertical ── */
  if(!isMobile){
    var track = document.querySelector('.usages__track');
    var getScroll = function(){ return track.scrollWidth - window.innerWidth; };
    gsap.to(track, {
      x:function(){ return -getScroll(); }, ease:'none',
      scrollTrigger:{
        trigger:'.usages', start:'top top',
        end:function(){ return '+=' + getScroll(); },
        scrub:true, pin:'.usages__track-wrap', invalidateOnRefresh:true
      }
    });
  } else {
    // Mobile : les panneaux passent en colonne (CSS reduced fallback) — simple reveal
    gsap.utils.toArray('.usages__panel').forEach(function(p){
      gsap.from(p.querySelector('.mot'), { y:20, opacity:0, duration:0.7, ease:EASE,
        scrollTrigger:{ trigger:p, start:'top 75%' } });
    });
  }

  /* ── 7 · COLORIS — sélecteur crossfade ── */
  var swatches = gsap.utils.toArray('.swatch');
  var imgs = {};
  document.querySelectorAll('.coloris__img').forEach(function(el){ imgs[el.dataset.c]=el; });
  var noms = { noir:'Noir', cognac:'Cognac' };
  var nomEl = document.getElementById('colorisNom');
  swatches.forEach(function(sw){
    sw.addEventListener('click', function(){
      var c = sw.dataset.c;
      swatches.forEach(function(s){ s.classList.remove('is-sel'); s.setAttribute('aria-pressed','false'); });
      sw.classList.add('is-sel'); sw.setAttribute('aria-pressed','true');
      Object.keys(imgs).forEach(function(k){ imgs[k].classList.toggle('is-on', k===c); });
      // petit change de nom animé
      gsap.fromTo(nomEl, { opacity:0, y:8 }, { opacity:1, y:0, duration:0.4, ease:EASE });
      nomEl.textContent = noms[c];
    });
  });

  /* ── 8 · CLÔTURE — révélation specs ── */
  gsap.from('.cloture__titre', { y:30, opacity:0, duration:0.9, ease:EASE,
    scrollTrigger:{ trigger:'.cloture', start:'top 75%' } });
  gsap.from('.specs tr', { opacity:0, y:14, duration:0.5, ease:EASE, stagger:0.06,
    scrollTrigger:{ trigger:'.specs', start:'top 80%' } });
  gsap.from('.cloture__buy', { opacity:0, y:20, duration:0.8, ease:EASE,
    scrollTrigger:{ trigger:'.cloture__buy', start:'top 88%' } });

  // Recalcule après chargement des images (évite le décalage sticky)
  window.addEventListener('load', function(){
    ScrollTrigger.refresh();
    if(lenis) lenis.resize();
    // 2e passe différée : images/fonts tardives qui changent la hauteur totale
    setTimeout(function(){ ScrollTrigger.refresh(); if(lenis) lenis.resize(); }, 600);
  });
})();

/* ── Sélecteur de pack (bundle) — toujours actif, hors animations ── */
(function(){
  var bundles = document.querySelectorAll('.bundle');
  var total = document.getElementById('bundleTotal');
  if(!bundles.length) return;
  bundles.forEach(function(b){
    b.addEventListener('click', function(){
      bundles.forEach(function(x){ x.classList.remove('is-sel'); x.setAttribute('aria-checked','false'); });
      b.classList.add('is-sel'); b.setAttribute('aria-checked','true');
      if(total) total.textContent = b.getAttribute('data-total');
    });
  });
})();

